



















import {Component, Prop, Vue} from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import PaymentForm from "@/components/for-payments-view/PaymentForm.vue";
import HelpCard from "@/components/for-payments-view/HelpCard.vue";
import {mapGetters, mapState} from "vuex";
import {paymentForm} from "@/assets/scripts/form-fields/main";

const { values } = paymentForm;

@Component({
  components: { Page, PaymentForm, HelpCard },
  computed: {
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({
      email: "user/email",
    }),
  },
})
class Payments extends Vue {
  [x: string]: any
  values = values

  mounted() {
    this.values = {...this.values, email: this.userEmail, amount: this.amount, total: this.total};
    this.defaultValues = {...this.values, email: this.userEmail, amount: this.amount, total: this.total};
  }

  get amount() {
    return this.$route.params.amount || 0
  }

  get total() {
    const { appEnviroment } = this;
    return +this.amount + (+this.amount * (+appEnviroment.constants["PaymentFee"] || 0))
  }

  get userEmail() {
    return this.email
  }

  get docs() {
    return this.$route.params.docs || ''
  }

  get paymentMode() {
    return this.$route.params.paymentMode || 'single'
  }
}

export default Payments;
